import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { StateUseContext } from '../context/UserDetailContext';
import moment from 'moment';
import swal from 'sweetalert';
import { salesforceSendFormNumber, savePaymentDetail } from '../actions/StudentAction';
import Logo from '../assets/images/logo.png';
import queryString from 'query-string';

const UpayPaymentSuccessful = () => {
  const { userDetail, feeDetail } = StateUseContext();
  const [hasUploadedData, setHasUploadedData] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const qParams = useParams();
  const queryParam = queryString.parse(location.pathname + location.search);
  const { id,form_num } = userDetail !== undefined && userDetail;
  const {
    installment,
    lumpsum,
    installment_type,
    net_payable_amount,
    scholarship_amount,
    scholarship_percentage,
    total_fee,
  } = feeDetail !== undefined && feeDetail;
  const [selectedInstallmentData, setSelectedInstallmentData] = useState(null);
  const { installmentNumber, payType, userId } = qParams;
  const currentDate = moment().format('YYYY-MM-DD');
  
  window.addEventListener('beforeunload', function (e) {
    e.preventDefault();
  });

  useEffect(() => {
    if (userDetail !== undefined && feeDetail !== undefined) {
      if (userDetail.id == userId) {
        if (payType === '1') {
          const foundInstallment =
            installment !== undefined &&
            installment?.find((installment) => installment.installment_number == installmentNumber);
          if (foundInstallment) {
            setSelectedInstallmentData(foundInstallment);
          }
        }
        if (payType === '2') {
          setSelectedInstallmentData(lumpsum);
        }
      }
    }
  }, [feeDetail, userDetail, userId, payType, installment, installmentNumber, lumpsum]);


  useEffect(() => {
    if (selectedInstallmentData && !hasUploadedData) {
        uploadUpayData();
        setHasUploadedData(true);
    }
  }, [selectedInstallmentData, hasUploadedData]);


  // let Order_id = qParams?.OrderID
  // let orderWithFormNum=`${id}-${qParams.OrderID}-${form_num}`
  // qParams.OrderID = orderWithFormNum
  // console.log('selectedInstallmentData...',)

  const uploadUpayData = async () => {
    setLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append( 'student_id', id);
    formDataToSend.append( 'amount', selectedInstallmentData?.amount);
    formDataToSend.append('pay_transaction_id', queryParam?.tran_id);
    formDataToSend.append('transaction_date', currentDate);
    formDataToSend.append('payment_type', 'Upay');
    formDataToSend.append('payment_mode', 'Online');
    formDataToSend.append('scholarship_amount', scholarship_amount);
    formDataToSend.append('net_payable_amount', net_payable_amount);
    formDataToSend.append( 'installments_id',selectedInstallmentData?.installment_id);
    formDataToSend.append('installment_type', selectedInstallmentData?.installment_number==0 ? 'lumpsum': installment_type);
    formDataToSend.append('scholarship_percentage', scholarship_percentage);
    formDataToSend.append('actual_inst_amt', selectedInstallmentData?.amount);
    formDataToSend.append('course_fee', total_fee);
    formDataToSend.append('transaction_status', 'COMPLETED');
    formDataToSend.append('installments_number', selectedInstallmentData?.installment_number);
    formDataToSend.append('response',JSON.stringify(queryParam));

    
    try {
      await savePaymentDetail(formDataToSend).then((res) => {
        if (res.status) {
          setLoading(false);
          salesforceSendFormNumber({form_num:form_num,status:'payment_approved'})
          swal('Congratulations Your fee submitted successfully.', '', 'success');
          navigate('/student/dashboard');
        }
      });
    } catch (error) {
      console.log('save payment error...', error);
    }
  };

  return loading ? (
    <div className="screenLoader text-center flex-wrap">
    <img src={Logo} alt="Loading..." style={{ width: '200px' }} />
    <span className="d-block w-100 fw-bold fs-6 text-center" style={{marginTop:'-50px'}}>PLEASE DO NOT REFRESH THE PAGE, AS THE PAYMENT IS CURRENTLY PROCESSING.</span>
  </div>
  ) : (
    ''
  );
};

export default UpayPaymentSuccessful;
